/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/is_not_null.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns `false` if the value is `NULL`, `true` otherwise.',
  examples: [
    'FROM employees\n| WHERE is_rehired IS NOT NULL\n| STATS COUNT(emp_no)',
  ],
  note: 'If a field is only in some documents it will be `NULL` in the documents that did not contain it.',
  params: {
    field: 'Value to check. It can be a single- or multi-valued column or an expression.',
  },
};

export default docs;
